<h2 mat-dialog-title>{{ 'balance.refund.title' | translate }}</h2>

<form [formGroup]="form" (ngSubmit)="submit()" class="balance-refund-dialog">
  <mat-dialog-content>
    <p class="balance-refund-dialog__source">
      {{ 'balance.refund.original-amount' | translate }}: {{ data.transaction.amount | currency:'USD' }}
    </p>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'balance.refund.amount' | translate }}</mat-label>
      <input
        matInput
        type="number"
        step="0.01"
        min="0.01"
        [max]="maxRefundAmount"
        formControlName="amount"
        data-balance-refund-amount />
    </mat-form-field>

    <mat-progress-bar *ngIf="isSubmitting" mode="indeterminate" data-balance-refund-progress></mat-progress-bar>

    <p *ngIf="errorMessage" class="balance-refund-dialog__error" data-balance-refund-error>
      {{ errorMessage }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" data-balance-refund-cancel>
      {{ 'balance.refund.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="warn"
      type="submit"
      [disabled]="form.invalid || isSubmitting"
      data-balance-refund-submit>
      {{ 'balance.refund.submit' | translate }}
    </button>
  </mat-dialog-actions>
</form>
